var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as R from 'ramda';
import { FormBaseElement, XbpmContext, XbpmActionType } from '@unitarius/xbpm-runtime';
import { BehaviorSubject } from 'rxjs';
import { skip, takeUntil, throttleTime } from "rxjs/operators";
import { ControlError } from './ControlError';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
var CLICK_THROTTLE_TIME = 300;
var requestProps = ['method', 'baseURL', 'headers', 'params', 'data'];
var mapRequest = function (def) { return !def ? {} : (__assign(__assign({}, R.pick(requestProps, def.frontOptions)), { url: def.value || def.frontOptions.src })); };
var eqByRequestConfig = R.eqBy(R.pipe(R.prop('def'), mapRequest));
var getRestProperties = R.pipe(omitSpecialProperties, R.omit(requestProps));
var ImageControl = /** @class */ (function (_super) {
    __extends(ImageControl, _super);
    function ImageControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._click$ = new BehaviorSubject(null);
        _this.click$ = _this._click$.pipe(skip(1), throttleTime(CLICK_THROTTLE_TIME), takeUntil(_this.destroy$));
        _this.updateLink = function () { return __awaiter(_this, void 0, void 0, function () {
            var request, link, fileService;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = mapRequest(this.state.def);
                        link = null;
                        if (!request.url) return [3 /*break*/, 2];
                        fileService = XbpmContext.getContext().getProvider('fileService');
                        return [4 /*yield*/, fileService.getFileUrl(request)];
                    case 1:
                        link = _a.sent();
                        _a.label = 2;
                    case 2:
                        this.revokeLink();
                        this.setState({ link: link }, this.forceUpdate);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.revokeLink = function () {
            if (_this.link) {
                URL.revokeObjectURL(_this.link);
            }
        };
        _this.onClick = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            _this._click$.next(evt);
        };
        return _this;
    }
    Object.defineProperty(ImageControl.prototype, "link", {
        get: function () {
            return this.state.link || '';
        },
        enumerable: false,
        configurable: true
    });
    ImageControl.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.updateLink();
        this.click$.subscribe(function () {
            var target = _this.state.def;
            var type = target.actionButton || XbpmActionType.FRONT_CLICK;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
        });
    };
    ImageControl.prototype.componentDidUpdate = function (_, prevState) {
        if (!eqByRequestConfig(prevState, this.state)) {
            this.updateLink();
        }
    };
    ImageControl.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.revokeLink();
    };
    ImageControl.prototype.elementRender = function (def) {
        var _a = def.frontOptions, widthImage = _a.widthImage, _b = _a.heightImage, heightImage = _b === void 0 ? '' : _b, src = _a.src, align = _a.align, hint = _a.hint, restOptions = __rest(_a, ["widthImage", "heightImage", "src", "align", "hint"]);
        var style = __assign({}, align ? { textAlign: align } : {});
        return def.hidden
            ? null
            : (React.createElement("div", { className: mapElementClass(def.frontOptions), style: style, "field-code": def.code },
                React.createElement(React.Fragment, null,
                    React.createElement("label", { title: def.label, htmlFor: def.id }, def.label),
                    React.createElement("img", __assign({ key: def.id, id: def.id, width: !widthImage ? '100%' : widthImage, height: heightImage, title: hint, src: this.link, alt: '', onClick: this.onClick }, getRestProperties(restOptions)))),
                React.createElement(ControlError, { error: this.error, touched: true })));
    };
    return ImageControl;
}(FormBaseElement));
export { ImageControl };
//# sourceMappingURL=Image.js.map